// Generic help text loader with locale fallback.
// The app registers markdown modules (from import.meta.glob) via initHelpTexts().

let defaultLocale = "de";
let markdownModules: Record<string, string> = {};

export function initHelpTexts(modules: Record<string, string>, locale: string = "de") {
    markdownModules = modules;
    defaultLocale = locale;
}

export function loadMd(id: string, locale: string = defaultLocale): string {
    const suffix = `/${locale}/${id}.md`;
    const entry = Object.entries(markdownModules).find(([key]) => key.endsWith(suffix));
    if (entry) {
        return entry[1];
    }

    const fallbackSuffix = `/${defaultLocale}/${id}.md`;
    const fallbackEntry = Object.entries(markdownModules).find(([key]) => key.endsWith(fallbackSuffix));
    if (fallbackEntry) {
        return fallbackEntry[1];
    }

    throw new Error(`Help text not found: ${id} (locale: ${locale})`);
}
